import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Market from './Market';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, myItems: data, overview } = state.market;
  return {
    isLoading,
    data,
    overview,
  };
}

const Styled = withStyles(styles)(Market);

export default connect(
  mapStateToProps,
)(Styled);
